<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo() {
    const meta = this.$route && this.$route.meta ? this.$route.meta : {}
    const title = meta.title || '官方网站'
    const description = meta.description || '官方网站'
    const url = typeof window !== 'undefined' ? window.location.href : ''
    return {
      title,
      meta: [
        { vmid: 'description', name: 'description', content: description },
        { vmid: 'og:type', property: 'og:type', content: 'website' },
        { vmid: 'og:title', property: 'og:title', content: title },
        { vmid: 'og:description', property: 'og:description', content: description },
        { vmid: 'og:url', property: 'og:url', content: url },
        { vmid: 'twitter:card', name: 'twitter:card', content: 'summary' },
        { vmid: 'twitter:title', name: 'twitter:title', content: title },
        { vmid: 'twitter:description', name: 'twitter:description', content: description }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: url }
      ]
    }
  },
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue